import { IntlShape, useIntl } from "react-intl";
import { ChevronDownIcon, ChevronUpIcon } from "@/icons";
import { Button } from "@/kit/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/kit/ui/dropdown-menu";
import React from "react";

interface Props<T> {
  readonly order: Readonly<T>;
  readonly orders: ReadonlyArray<T>;
  readonly onChange: (order: Readonly<T>) => void;
  readonly format: (intl: IntlShape, order: Readonly<T>) => string;
}

export function OrderSelect<T>(props: Readonly<Props<T>>) {
  const [dropdownOpen, setDropdownOpen] = React.useState(false);
  const intl = useIntl();

  return (
    <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
      <DropdownMenuTrigger asChild>
        <Button variant="tertiary" size="md" hue="grey">
          {props.format(intl, props.order)}
          {dropdownOpen ? (
            <ChevronUpIcon className="text-grey-700" />
          ) : (
            <ChevronDownIcon className="text-grey-700" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {props.orders.map((order, index) => (
          <DropdownMenuItem key={index} onClick={() => props.onChange(order)}>
            {props.format(intl, order)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
